import { Tag } from 'palette/Tag';
import { Small } from 'palette/Typography';

interface CountBadgeProps {
    count: string | number;
    className?: string;
    isColorBadge?: boolean;
    isDisabled?: boolean;
}

export default function CountBadge({
    className, count, isColorBadge, isDisabled,
}: CountBadgeProps) {
    if (isColorBadge) {
        return (
            <Tag
                className={className}
                label={count}
                theme="primary"
            />
        );
    }

    return (
        <Small
            className={className}
            color={isDisabled ? 'lighter' : 'light'}
        >
            {`(${count})`}
        </Small>
    );
}
